import Phaser from 'phaser';
import { SCENES, DESIGN_WIDTH, DESIGN_HEIGHT } from '../constants';
import { SceneRouter } from '../systems/SceneRouter';
import { InputRouter } from '../systems/InputRouter';
import { AudioRouter } from '../systems/AudioRouter';
import { AuthService } from '../systems/AuthService';
import { SaveSyncService } from '../systems/SaveSyncService';
import { AuthUI } from '../systems/AuthUI';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: SCENES.BOOT });
  }

  create(): void {
    console.log('[BootScene] Initializing game systems...');

    // Initialize scene router with game instance
    SceneRouter.init(this.game);
    SceneRouter.setCurrentScene(SCENES.BOOT);

    // Show loading text
    const loadingText = this.add.text(DESIGN_WIDTH / 2, DESIGN_HEIGHT / 2, 'Loading...', {
      fontSize: '32px',
      color: '#ffffff',
    });
    loadingText.setOrigin(0.5);

    // Register sync-conflict handler before auth init (so conflict dialog can show when both local and remote have data)
    SaveSyncService.setConflictHandler((actions) => AuthUI.showSyncConflictDialog(actions));

    // Initialize auth service (non-blocking — game continues even if server is down)
    AuthService.init().catch(() => {
      console.log('[BootScene] Auth init skipped (server unavailable)');
    });

    // Initialize systems and proceed to preload
    this.time.delayedCall(100, () => {
      SceneRouter.startPreload(SCENES.BOOT);
    });
  }
}
